import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { AuthService } from '../auth.services'

@Injectable()
export class AvailabilityGuard implements CanActivate {
    constructor(private authService: AuthService,
                private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean>|Promise<boolean>|boolean {
        //
        const user = this.authService.getUser()
        try {
            if (user && user.availability != 'Off') {
                return true
            }
        } catch (e) {
            console.log(e)
        }
        if(user)
            this.router.navigateByUrl('/app/top')
        return false
    }
}



// WEBPACK FOOTER //
// ./src/app/services/guarad/availability.guard.ts